import { DateTime } from "luxon";
import React, { useCallback, useEffect, useState } from "react";
import NotifContainer from "../Notifications/NotifContainer";
import "./notifications.scss";
import { notifActions } from "../../../context/actions/notifActions";
import dataService from "../../../helpers/dataService";
import useStore from "../../../context/useStore";

export const DELAI_ACTUALISATION = 60000;

// Cloche des notifications, placée dans le menu latéral : sous l'en-tête en
// rail et en épinglé, en bout de barre haute en tiroir. Les notifications sont
// relues toutes les minutes ; un clic ouvre le panneau NotifModal.
// `variante` : "rail" (icône + infobulle), "epingle" (icône + libellé) ou
// "tiroir" (icône blanche de la barre haute).
const Notifications = ({ variante = "rail" }) => {
  const [state, dispatch] = useStore();
  const nActions = notifActions(state, dispatch);
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    let minuterie = null;
    let actif = true;
    const lire = () => {
      dataService.get(`notifications/mines`, (donnees) => {
        if (actif) setNotifications(Array.isArray(donnees) ? donnees : []);
      });
      minuterie = setTimeout(lire, DELAI_ACTUALISATION);
    };
    lire();
    return () => {
      actif = false;
      clearTimeout(minuterie);
    };
  }, []);

  const updateReadStatus = useCallback((isRead, id) => {
    setNotifications((liste) =>
      liste.map((n) => {
        if (String(n.id) === String(id)) {
          n.readAt = isRead ? DateTime.local().toISO() : false;
        }
        return n;
      })
    );
  }, []);

  const openNotif = () => {
    nActions.updateNotif({
      isOpen: true,
      content: <NotifContainer notifications={notifications} updateReadStatus={updateReadStatus} />,
    });
  };

  const nonLues = notifications.filter((n) => !n.readAt).length;
  const libelle = nonLues > 0 ? `Notifications, ${nonLues} non lue${nonLues > 1 ? "s" : ""}` : "Notifications";
  const tiroir = variante === "tiroir";

  return (
    <button
      type="button"
      className={tiroir ? "menu-lateral__bouton menu-notifications menu-notifications--tiroir" : "menu-lateral__item menu-notifications"}
      aria-label={libelle}
      onClick={openNotif}
    >
      <span className="menu-notifications__icone" aria-hidden="true">
        <i className="fa fa-bell" />
        {nonLues > 0 && <span className="menu-notifications__compteur">{nonLues > 99 ? "99+" : nonLues}</span>}
      </span>
      {!tiroir && (
        <span className="menu-lateral__libelle" aria-hidden="true">
          Notifications
        </span>
      )}
      {variante === "rail" && (
        <span className="menu-lateral__bulle" aria-hidden="true">
          {libelle}
        </span>
      )}
    </button>
  );
};

export default Notifications;
